import { Box, Container, Typography, Paper, Stack } from '@mui/material';
import { EmailOutlined as EmailIcon } from '@mui/icons-material';
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, SUPPORT_EMAIL } from '../../lib/constants';
import Button from '../../components/Button';
import Navbar from '../../components/Navbar';
import Footer from '../landing/Footer';

function ContactPage({ auth }) {
  const authed = auth?.status === 'authenticated';

  return (
    <Box component="main">
      <Navbar authed={authed} />
      <Container maxWidth="sm" sx={{ py: { xs: 8, md: 12 }, textAlign: 'center' }}>
        <Typography variant="h3" fontWeight={700} sx={{ fontSize: { xs: '1.75rem', sm: '2.25rem' }, mb: 1.5 }}>
          Contact us
        </Typography>
        <Typography variant="h6" fontWeight={400} color="text.secondary" sx={{ mb: 4 }}>
          Questions, feedback, or need help with your account? Our team is happy to help.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ alignItems: 'stretch' }}>
          <Paper variant="outlined" sx={{ p: 4, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <EmailIcon sx={{ fontSize: 32, color: 'primary.main' }} />
            <Typography variant="h6" fontWeight={700} sx={{ overflowWrap: 'anywhere' }}>
              {SUPPORT_EMAIL}
            </Typography>
            <Button href={`mailto:${SUPPORT_EMAIL}`} sx={{ mt: 'auto' }}>Email our team</Button>
          </Paper>
          <Paper variant="outlined" sx={{ p: 4, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box component="img" src="/Instagram_logo.svg" alt="" sx={{ width: 32, height: 32 }} />
            <Typography variant="h6" fontWeight={700}>
              {INSTAGRAM_HANDLE}
            </Typography>
            <Button href={INSTAGRAM_URL} target="_blank" rel="noreferrer" sx={{ mt: 'auto' }}>Message us on Instagram</Button>
          </Paper>
        </Stack>
      </Container>
      <Footer />
    </Box>
  );
}

export default ContactPage;
